module.exports = __webpack_public_path__ + "img/user-guide-02-04-01.2eb649f1.png";